import type {CalendarEntry, Content} from '../../lib/types';
import {localCandidates, localDate, timeLabel} from '../../lib/time';

export type PlanItem = {content: Content; entry?: CalendarEntry};
export type PlanSelection = PlanItem & {local: string};
export const editorPath = (content: Content) => content.kind === 'article' ? `/knowledge/${content.articleId || content.id}` : `/content/${content.id}`;
export function movable(entry: CalendarEntry) {
  return entry.contentState === 'scheduled' && (!entry.attemptStatus || ['queued', 'scheduled'].includes(entry.attemptStatus));
}
export function entryItem(entry: CalendarEntry): PlanItem {
  return {entry, content: {id: entry.itemId, kind: entry.kind === 'article' ? 'article' : 'social', title: entry.title, resourceId: entry.resourceId, version: 0, thumbnailUrl: entry.thumbnailUrl}};
}
export function nextLocal(day = localDate(new Date())) {
  const now = new Date();
  if (day > localDate(now)) return `${day}T09:00`;
  const next = new Date(Math.ceil((now.getTime() + 15 * 60_000) / 1_800_000) * 1_800_000);
  return `${localDate(next)}T${timeLabel(next.toISOString()).replace('.', ':')}`;
}
export function futureSlot(local: string) {
  return localCandidates(local).some(instant => Date.parse(instant) > Date.now());
}
